import api from "./api";

const API_URL = "/parcel";

// =====================
// GET ALL
// =====================
export const getParcels = async () => {
    const res = await api.get(API_URL);
    return res.data;
};

// =====================
// GET BY ID
// =====================
export const getParcel = async (id) => {
    const res = await api.get(`${API_URL}/${id}`);
    return res.data;
};

// =====================
// CREATE
// =====================
export const createParcel = async (data) => {
    const res = await api.post(API_URL, data);
    return res.data;
};

// =====================
// UPDATE
// =====================
export const updateParcel = async (id, data) => {
    const res = await api.put(`${API_URL}/${id}`, data);
    return res.data;
};

// =====================
// DELETE
// =====================
export const deleteParcel = async (id) => {
    const res = await api.delete(`${API_URL}/${id}`);
    return res.data;
};

export default {
    getParcels,
    getParcel,
    createParcel,
    updateParcel,
    deleteParcel
};